<template>
  <modal
    ref="disableUserModal"
    template="neutral"
    title="Aviso"
    ref-name="disableUserModal"
    class="disable-user-modal"
  >
    <div
      class="disable-user-modal__wrapper"
      :class="{ 'disable-user-modal__wrapper--loading': loading }"
    >
      <spinner
        v-if="loading"
        class="loading"
      />
      <template v-else>
        <div v-if="user">
          <p>Tem certeza de que você quer excluir esse membro da equipe?</p>
          <div class="disable-user-modal__box-user">
            <span>
              {{ user.name }}
            </span>
          </div>
          <div class="disable-user-modal__actions">
            <button
              class="btn btn-cancel"
              @click="closeDisableUserModal"
            >
              Cancelar
            </button>
            <button
              class="btn btn-primary btn-new error"
              @click="disableUser"
            >
              <img src="/static/images/perfil-de-acesso/close-radius.svg">
              Excluir
            </button>
          </div>
        </div>
      </template>
    </div>
  </modal>
</template>
<script>
import userManagementService from '@/api/userManagement'
import notify from '@/api/notification'
import Spinner from '@/components/common/Spinner'
import { mapActions } from 'vuex'
export default {
  name: 'DisableUserModal',
  components: {
    Spinner
  },
  data() {
    return {
      loading: false,
      user: null
    }
  },
  methods: {
    ...mapActions(['getTeamList']),
    openDisableUserModal(user) {
      this.user = user
      this.$refs.disableUserModal.open()
    },
    closeDisableUserModal() {
      this.$refs.disableUserModal.close()
    },
    disableUser() {
      this.loading = true
      userManagementService
        .deleteMember(this.user.id)
        .then(res => {
          this.loading = false
          this.$refs.disableUserModal.close()
          this.getTeamList()
          notify({
            title: 'AVISO: ',
            message: 'Usuário desativado com sucesso!'
          })
        })
        .catch(err => {
          this.loading = false
          console.error('err -->', err)
          notify({
            title: 'AVISO: ',
            message: 'Não foi possível desativar este usuário'
          })
        })
    }
  }
}
</script>
 <style lang="scss">
.disable-user-modal {
  .md-dialog {
    width: 90%;
    max-width: 580px;
    min-height: 275px;
    padding: 50px 80px;
    &-content,
    &-title {
      padding: 0;
    }
    &-title {
      .md-icon {
        margin: 0;
        margin-right: 10px;
      }
    }
  }
  &__wrapper {
    margin-top: 16px;
    font-family: 'Exo 2', sans-serif !important;
    &--loading {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  &__box-user {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 24px;
    background: rgba(22, 22, 22, 0.04);
    border-radius: 6px;
    margin-top: 10px;
    font-weight: 400;
    font-size: 14px;
    font-family: 'Exo 2', sans-serif !important;
    span {
      font-weight: 500;
      font-size: 16px;
      color: #4a4a4a;
    }
  }
  &__actions {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
    .btn {
      width: 130px;
    }
    .error {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        margin-right: 8px;
      }
    }
  }
}
</style>
